module.exports = __webpack_public_path__ + "img/IconWoundCare.35d0b1db.svg";